export type routeParseType = {
  name: string;
  params: ParamsType;
};

export type ParamsType = {
  id: string;
  code: string;
};

const routeParse = (
  id: string,
  code: string,
  name: string = 'event-card'
): routeParseType => ({
  name,
  params: { id, code },
});

export default routeParse;



// WEBPACK FOOTER //
// ./src/pages/profile/utils/routeParse.ts